export default "__VITE_ASSET__DpLh8$aH__"